import { config, library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faGraduationCap,
  faKey,
  faSignOutAlt,
  faSpinner,
  faTimes,
  faTruck,
  faUser,
  faUsers,
  faEye,
  faEyeSlash,
  faCogs,
  faPlayCircle,
  faHome,
  faSignInAlt,
  faSearch,
  faUserCircle,
  faCubes,
  faChartLine,
  faAngleDown,
  faAngleUp,
  faAddressCard,
  faUserEdit,
  faUserFriends,
  faClockFour,
  faIdCard,
  faUserPlus,
  faCalendarXmark,
  faFileText,
  faTools,
  faTowerCell,
  faUserDoctor,
  faFileCircleExclamation,
  faFileSignature,
  faImage,
  faCreditCard,
  faSliders,
  faCircleXmark,
  faCircleCheck,
  faCircleQuestion,
  faCircleExclamation,
  faCirclePlay,
  faRecycle,
  faMagnifyingGlass,
  faHospital,
  faPercent,
  faEnvelope,
  faMailBulk

} from '@fortawesome/free-solid-svg-icons';

import { faUserCircle as faUserCircleRegular } from '@fortawesome/free-regular-svg-icons';

// Important for CSP - see https://fontawesome.com/how-to-use/on-the-web/other-topics/security
config.autoAddCss = false;

library.add(
  faTruck,
  faGraduationCap,
  faUser,
  faUsers,
  faSignOutAlt,
  faKey,
  faTimes,
  faCheck,
  faSpinner,
  faEye,
  faEyeSlash,
  faCogs,
  faPlayCircle,
  faHome,
  faSignInAlt,
  faSearch,
  faUserCircle,
  faUserCircleRegular,
  faCubes,
  faChartLine,
  faAngleDown,
  faAngleUp,
  faAddressCard,
  faUserEdit,
  faUserFriends,
  faCalendarXmark,
  faClockFour,
  faIdCard,
  faUserPlus,
  faFileText,
  faTools,
  faTowerCell,
  faUserDoctor,
  faFileCircleExclamation,
  faFileSignature,
  faImage,
  faCreditCard,
  faSliders,
  faCircleQuestion,
  faCircleXmark,
  faCircleCheck,
  faCircleExclamation,
  faCirclePlay,
  faRecycle,
  faMagnifyingGlass,
  faHospital,
  faPercent,
  faEnvelope,
  faMailBulk
);
